import { all, takeLatest } from 'redux-saga/effects';
import authTypes from 'reduxConfig/auth.types';
import {
  authGetUser,
  authLogin,
  authResetPassword,
  authResetPasswordReturn,
  authSendEmailVerification,
  authEmailVerificationReturn,
  authRecoverEmail,
  authSignup,
  authVerifyEmail,
  authVerifyLogin,
  authVerifyLoginMobile,
  reauthenticateFirebase,
  initFirebaseMfa,
  verifyFirebaseMfaCode,
  processFirebaseLoginSuccess
} from './saga';

export default function* saga() {
  yield all([
    takeLatest(authTypes.AUTH_GET_USER, authGetUser),
    takeLatest(authTypes.AUTH_LOGIN, authLogin),
    takeLatest(authTypes.REAUTHENTICATE, reauthenticateFirebase),
    takeLatest(authTypes.AUTH_RESET_PASSWORD, authResetPassword),
    takeLatest(authTypes.AUTH_RESET_PASSWORD_RETURN, authResetPasswordReturn),
    takeLatest(authTypes.AUTH_SEND_EMAIL_VERIFICATION, authSendEmailVerification),
    takeLatest(authTypes.AUTH_VERIFY_EMAIL_RETURN, authEmailVerificationReturn),
    takeLatest(authTypes.AUTH_RECOVER_EMAIL, authRecoverEmail),
    takeLatest(authTypes.AUTH_SIGNUP, authSignup),
    takeLatest(authTypes.AUTH_VERIFY_EMAIL, authVerifyEmail),
    takeLatest(authTypes.AUTH_VERIFY_LOGIN, authVerifyLogin),
    takeLatest(authTypes.AUTH_VERIFY_LOGIN_MOBILE, authVerifyLoginMobile),
    takeLatest(authTypes.FIREBASE_MFA_INIT, initFirebaseMfa),
    takeLatest(authTypes.FIREBASE_MFA_VERIFY_CODE, verifyFirebaseMfaCode),
    takeLatest(authTypes.FIREBASE_LOGIN_SUCCESS, processFirebaseLoginSuccess)
  ]);
}
